import type { ReactNode } from "react";
import { KlarityMark } from "../../components/ui/KlarityMark";

/**
 * The frame of the pages outside the shell (sign-in, no access): the rail's dark ground with the mark and the
 * product name, then the page's own content. Side by side from 768 pixels, a band above the content below that.
 */
export function BrandFrame({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-full flex-col bg-desk md:flex-row">
      <div className="flex shrink-0 items-center gap-4 bg-rail px-6 py-7 md:w-2/5 md:max-w-lg md:flex-col md:items-start md:justify-center md:gap-7 md:px-12 lg:px-16">
        <KlarityMark className="h-9 w-7.25 md:h-15 md:w-12" />
        <p className="text-2xl font-semibold text-white md:text-3xl">Klarity Docs</p>
      </div>
      <main className="grid flex-1 place-items-center px-6 py-10 md:px-10">
        <div className="w-full max-w-sm">{children}</div>
      </main>
    </div>
  );
}
